import {html, PolymerElement} from '@polymer/polymer/polymer-element.js';
import '@polymer/paper-card/paper-card.js';
import '@cbar/cbar-shared-styles/cbar-shared-styles.js'
import '@polymer/iron-icons/communication-icons.js';
import '@polymer/iron-image/iron-image.js';
import '@polymer/paper-icon-button/paper-icon-button.js';
import '@polymer/paper-menu-button/paper-menu-button.js';
import '@polymer/iron-icons/iron-icons.js';
import '@polymer/iron-icons/social-icons.js';
import '@polymer/iron-icon/iron-icon.js';

/**
 * `cbar-sales-public-card`
 *
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class CbarSalesPublicCard extends PolymerElement {
  static get template() {
    return html`
        <style include="cbar-shared-styles">
            :host {
                display: flex;
            }

            #top-image {
                height: 0;
                position: absolute;
                padding-top: 56.25%;
                width: 100%;
            }

            .card-content {
                padding: 0;
            }

            #card-image {
                height: 0;
                padding-top: 56.25%;
                width: 100%;
            }

            #event-details {
                width: 100%;
            }

            #event-details {
                padding: 32px;
                width: 25%;
                align-self: flex-start;
            }

            iron-icon {
                margin-right: 5px;
                min-width: 25px;
            }

            paper-card {
                width: 100%;
                max-width: 1080px;
                margin-bottom: 40px;
            }

            .card-image-div {
                flex: 1;
                position: relative;
            }

            .vertical-flex {
                flex-direction: column;
                display: flex;
            }

            .icon-label {
                flex-wrap: wrap;
            }

            .icon-div {
                display: flex;
                margin-bottom: 16px;
            }
            
            :host([compact]) #location-details .icon-div {
                margin-bottom: 0 !important;
            }
            
            .title-div {
                text-align: left;
            }

            #location-details {
                width: calc(25% + 32px);
                padding-left: 16px;
            }

            #event-info {
                width: 100%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
            }

            #summary {
                flex: 1;
            }

            .details-div {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }

            #logo-image {
                z-index: 1;
                width: 200px;
                height: 200px;
                position: absolute;
                border-radius: 50%;
                border: 2px solid white;
                left: 24px;
                top: 0;
                bottom: 0;
                margin: auto;
            }

            #logo-image-small {
                z-index: 1;
                width: 48px;
                height: 48px;
                border-radius: 50%;
                margin: auto;
            }

            /* these could be put in the owner section depending on what is put into the owner value*/
            a {
                color: var(--cbar-sys-color-primary, #004CA2);
                text-decoration: none;
            }

            .description-div {
                display: flex;
                justify-content: space-between;
            }

            [hidden] {
                opacity: 0;
            }

            @media (max-width: 600px) {
                .title-div {
                    padding: 16px;
                }

                .card-image-div {

                    width: 100%;
                    margin-bottom: 16px;
                }

                #event-details {
                    width: 100%;
                }

                #event-info {
                    flex-direction: column;
                    justify-content: center;
                    text-align: center;
                    padding-bottom: 16px;
                }

                .card-content {
                    width: 100%;
                }

                #event-details {
                    border-left: 0;
                    padding: 0;
                }

                .vertical-divide {
                    flex-direction: column;
                }

                .icon-div {
                    text-align: left;
                }
                
                #time-div{
                    align-self: center;
                }
            }
        </style>
        <paper-card id="summary-card">
            <div class="card-content" id="summary-card-content">
                <div id="event-info">

                    <template is="dom-if" if="[[!compact]]">
                        <div class="vertical-flex card-image-div">
                            <iron-image hidden$="[[!__showBigLogo]]" src="[[logoImage]]" sizing="cover"
                                id="logo-image"></iron-image>
                            <iron-image src="[[bannerImage]]" sizing="cover" id="card-image"
                                position="top"></iron-image>
                        </div>

                        <div id="event-details" class="vertical-flex">
                            <div class="title-div">
                                <h5 hidden$="[[!title]]" style="margin-bottom: 0">[[title]]</h5>
                                <div hidden$="[[!owner]]" class="icon-div"><span
                                    class="icon-label secondary-text owner-div"></span></div>
                            </div>
                        </div>
                    </template>
                </div>

                <div style="padding: 16px;">
                    <div class="description-div">
                        <div>
                            <div style="display:flex;align-items:center;gap:8px;margin-bottom:16px;">
                                <div hidden$="[[!__showSmallLogo]]">
                                  <iron-image hidden$="[[!__showSmallLogo]]" src="[[logoImage]]" sizing="cover" id="logo-image-small"></iron-image>
                                </div>
                              
                              <h6 id="sub-header" style="margin:0"></h6>
                            </div>
                            <template is="dom-if" if="[[compact]]">
                                <div id="summary" class="body-text-2" style="margin-bottom: 8px"></div>
                            </template>
                        </div>
                        <paper-menu-button horizontal-align="right" vertical-offset="50" id="menuContainer" hidden
                            style="padding: 0; height: 24px; width: 24px;">
                            <paper-icon-button icon="more-vert" slot="dropdown-trigger"></paper-icon-button>
                            <slot name="menu-items" on-slotchange="_menuSlotChanged" slot="dropdown-content"></slot>
                        </paper-menu-button>
                    </div>
                    <div class="details-div">
                        <div>
                            <template is="dom-if" if="[[!compact]]">
                                <div id="summary" class="body-text-2" style="margin-bottom: 8px"></div>
                                <template is="dom-if" if="[[__displayLeftDetails]]">
                                  <div hidden$="[[!time]]" class="icon-div body-text-2" style="margin-top:24px">
                                      <iron-icon icon="icons:date-range"></iron-icon>
                                      <span class="icon-label" id="time-div"></span></div>
                                  <div hidden$="[[!location]]" class="icon-div body-text-2">
                                      <iron-icon icon="communication:location-on"></iron-icon>
                                      <span class="icon-label" id="location-div"></span></div>
                                </template>
                            </template>
                            <template is="dom-if" if="[[compact]]">
                                <div hidden$="[[!time]]" class="icon-div body-text-2">
                                    <iron-icon icon="icons:date-range"></iron-icon>
                                    <span class="icon-label" id="time-div"></span></div>
                                <div hidden$="[[!location]]" class="icon-div body-text-2">
                                    <iron-icon icon="communication:location-on"></iron-icon>
                                    <span class="icon-label" id="location-div"></span></div>
                            </template>
                        </div>
                        <div id="location-details">
                            <template is="dom-if" if="[[compact]]">
                                <div hidden$="[[!owner]]" class="icon-div"><span class="icon-label secondary-text"><b
                                    class="owner-div"></b></span></div>
                            </template>
                            <template is="dom-if" if="[[__displayRightDetails]]">   
                                <div hidden$="[[!time]]" class="icon-div body-text-2">
                                    <iron-icon icon="icons:date-range"></iron-icon>
                                    <span class="icon-label" id="time-div"></span></div>
                                <div hidden$="[[!location]]" class="icon-div body-text-2">
                                    <iron-icon icon="communication:location-on"></iron-icon>
                                    <span class="icon-label" id="location-div"></span></div>
                            </template>
                            <slot name="extra-details"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </paper-card>
    `;
  }

  static get properties() {
    return {
      bannerImage: {
        type: String,
        value: ""
      },
      logoImage: {
        type: String,
        value: false
      },
      title: {
        type: String,
        value: ""
      },
      description: {
        type: String,
        value: false,
        observer: "__handleSummary"
      },
      owner: {
        type: String,
        value: "",
        observer: '__handleOwner'
      },
      time: {
        type: String,
        value: false,
        observer: "__injectTime"
      },
      location: {
        type: String,
        value: "",
        observer: "__injectLocation"
      },
      compact: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      showSecondaryTitle: {
        type: Boolean,
        value: false
      },
      smallLogoImage: {
        type: Boolean,
        value: false,
      },
      detailsPosition: {
        type: String,
        value: "right",
      }
    };
  }

  static get observers(){
    return [
      'handleLogoImage(smallLogoImage, logoImage)',
      'handleSecondaryTitle(showSecondaryTitle, compact)',
      "__handleDetailsPosition(detailsPosition, compact)"
    ]
  }

  ready() {
    super.ready();

    requestAnimationFrame(() => {
      this.__setSubheaderTitle();
    });
  }

  get summaryDiv() {
    if (!this.__summaryDiv) {
      this.__summaryDiv = this.root.querySelector('#summary');
    }
    return this.__summaryDiv;
  }

  get ownerDiv() {
    if (!this.__ownerDiv) {
      this.__ownerDiv = this.root.querySelector('.owner-div')
    }
    return this.__ownerDiv;
  }

  get subheaderSection() {
    if (!this.__subheaderSection) {
      this.__subheaderSection = this.root.querySelector('#sub-header');
    }
    return this.__subheaderSection;
  }

  get descriptionDiv(){
    if(!this.__descriptionDiv){
      this.__descriptionDiv = this.root.querySelector('.description-div');
    }
    return this.__descriptionDiv;
  }


  __injectTime(time) {
    requestAnimationFrame(() => {
      if (!time) {
        return
      }
      this.root.querySelector('#time-div').innerHTML = time;
    });
  }

  __handleSummary(summary) {
    requestAnimationFrame(() => {
      if (!summary) {
        return
      }

      this.summaryDiv.innerHTML = summary;
    });
  }

  __handleOwner(owner) {
    requestAnimationFrame(() => {
      if (!owner || !this.ownerDiv) {
        return;
      }
      this.ownerDiv.innerHTML = owner;
    })
  }

  _menuSlotChanged(e) {
    this.$.menuContainer.hidden = !e.target.assignedNodes({flatten: true}).length;
  }

  __injectLocation(location) {
    requestAnimationFrame(() => {
      if (!location) {
        return;
      }
      this.root.querySelector('#location-div').innerHTML = location;
    });
  }

  __getCardSubHeader() {
    return this.__showSecondaryTitle ? this.title : "";
  }

  __checkHiddenDescription() {
    return this.compact ? false : !this.description;
  }

  __setSubheaderTitle() {
    this.subheaderSection.hidden = this.__checkHiddenDescription();
    this.subheaderSection.innerHTML = this.__getCardSubHeader();
  }

  handleLogoImage(smallLogoImage, logoImage){
    this.__showBigLogo = logoImage && !smallLogoImage;
    this.__showSmallLogo = logoImage && smallLogoImage
  }

  handleSecondaryTitle(secondaryTitle, compact){
    this.__showSecondaryTitle = secondaryTitle || compact;
  }

  __handleDetailsPosition(position, compact){
    this.__displayRightDetails = position === "right" && !compact;
    this.__displayLeftDetails = !this.__displayRightDetails && !compact;
  }
}

window.customElements.define('cbar-sales-public-card', CbarSalesPublicCard);
